import type { LogAttributes } from './types';

export const toErrorMessage = (error: unknown): string =>
  error instanceof Error ? error.message : typeof error === 'string' ? error : String(error);

export const flattenErrorAttribute = (attributes?: LogAttributes): { attributes?: LogAttributes; rawError: unknown } => {
  const rawError = attributes?.error;
  if (rawError === undefined) return { attributes, rawError: undefined };
  return { attributes: { ...attributes, error: toErrorMessage(rawError) }, rawError };
};
